import type { CrochetType } from './types';

/**
 * Stitch-local normalized coordinates.
 *   x ∈ [-0.5, 0.5]  tangential — along the ring; left = -0.5, right = +0.5.
 *   y ∈ [0, 1]       radial    — y=0 inner-ring side, y=1 outer-ring side.
 */
export type Point = { x: number; y: number };

export type Primitive =
    | { kind: 'line'; from: Point; to: Point }
    | { kind: 'radialLine'; x: number; y0: number; y1: number }
    | { kind: 'tangentialArc'; y: number; x0: number; x1: number }
    | {
          kind: 'ellipse';
          cx: number;
          cy: number;
          rx: number;
          ry: number;
          rotation: number; // radians
          fill: boolean;
      }
    | { kind: 'dot'; cx: number; cy: number; r: number };

const CHAIN_LINK_RX_HORIZONTAL = 0.42;
const CHAIN_LINK_RY_HORIZONTAL = 0.18;
const CHAIN_LINK_RX_VERTICAL = CHAIN_LINK_RY_HORIZONTAL;
const CHAIN_LINK_RY_VERTICAL = CHAIN_LINK_RX_HORIZONTAL;

export const CROCHET_GEOMETRY: Record<CrochetType, Primitive[]> = {
    'chain-up': [
        {
            kind: 'ellipse',
            cx: 0,
            cy: 0.5,
            rx: CHAIN_LINK_RX_VERTICAL,
            ry: CHAIN_LINK_RY_VERTICAL,
            rotation: 0,
            fill: false,
        },
    ],
    'chain-center': [
        {
            kind: 'ellipse',
            cx: 0,
            cy: 0.5,
            rx: CHAIN_LINK_RX_HORIZONTAL,
            ry: CHAIN_LINK_RY_HORIZONTAL,
            rotation: 0,
            fill: false,
        },
    ],
    'slip-stitch': [{ kind: 'dot', cx: 0, cy: 0.5, r: 0.06 }],
    'single-crochet-x': [
        { kind: 'line', from: { x: -0.4, y: 1 }, to: { x: 0.4, y: 0 } },
        { kind: 'line', from: { x: 0.4, y: 1 }, to: { x: -0.4, y: 0 } },
    ],
    'single-crochet-crosshair': [
        { kind: 'radialLine', x: 0, y0: 0, y1: 1 },
        { kind: 'line', from: { x: -0.4, y: 0.5 }, to: { x: 0.4, y: 0.5 } },
    ],
    'half-double-crochet': [
        { kind: 'radialLine', x: 0, y0: 0, y1: 1 },
        { kind: 'line', from: { x: -0.4, y: 0.85 }, to: { x: 0.4, y: 0.85 } },
    ],
};
